/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapportinoFileDTO
 */
export interface RapportinoFileDTO {
    /**
     * 
     * @type {number}
     * @memberof RapportinoFileDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportinoFileDTO
     */
    base64?: string | null;
}

/**
 * Check if a given object implements the RapportinoFileDTO interface.
 */
export function instanceOfRapportinoFileDTO(value: object): value is RapportinoFileDTO {
    return true;
}

export function RapportinoFileDTOFromJSON(json: any): RapportinoFileDTO {
    return RapportinoFileDTOFromJSONTyped(json, false);
}

export function RapportinoFileDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportinoFileDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'base64': json['base64'] == null ? undefined : json['base64'],
    };
}

export function RapportinoFileDTOToJSON(json: any): RapportinoFileDTO {
    return RapportinoFileDTOToJSONTyped(json, false);
}

export function RapportinoFileDTOToJSONTyped(value?: RapportinoFileDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'base64': value['base64'],
    };
}

